var _CssBaseline;
import React from 'react';
import { useImTheme } from '@im/im-theme';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var MuiProviders = function MuiProviders(props) {
  var children = props.children;
  var _useImTheme = useImTheme(),
    theme = _useImTheme.theme;
  return /*#__PURE__*/_jsxs(ThemeProvider, {
    theme: theme,
    "data-element": "ThemeProvider",
    "data-component": "MuiProviders",
    "data-source-file": "MuiProviders.tsx",
    children: [_CssBaseline || (_CssBaseline = /*#__PURE__*/_jsx(CssBaseline, {
      enableColorScheme: true,
      "data-element": "CssBaseline",
      "data-source-file": "MuiProviders.tsx"
    })), children]
  });
};